export const HANDLE_SHARE_PLAN_CHANGE = 'HANDLE_SHARE_PLAN_CHANGE'
export const handleChange = props => {
  return {
    props,
    type: HANDLE_SHARE_PLAN_CHANGE
  }
}
